import { useEffect, useState, useRef } from "react";
import "./Dropdown.css";

const Dropdown_aspect = (props) => {
  const { label, value, onChange, options, inputBox,selectedID } = props;
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);

  let useClickOutside = (handler) => {
    let domNode = useRef();

    useEffect(() => {
      let isHandler = (event) => {
        if (!domNode.current.contains(event.target)) {
          handler();
        }
      };

      document.addEventListener("mousedown", isHandler);

      return () => {
        document.removeEventListener("mousedown", isHandler);
      };
    });

    return domNode;
  };

  let domNode = useClickOutside(() => {
    setIsOptionsVisible(false);
  });

  const handleSelected = (value) => {
    onChange(value);
    setIsOptionsVisible(false);
  };
  let displayValue = value;
  const idx = options?.findIndex((opt) => opt.value === value);
  if (idx !== undefined && idx !== -1) displayValue = options[idx].label;
  return (
    <div className="DDContainer">

      {label && <span className="DD-label mr-5"
      style={{color:( label === "Aspect ratio")? '#fff' : '#c5c5c5',
        fontWeight: '500'
      }}
      >{label}</span>}


      <div ref={domNode} className="DDContainer-component">

        <div className="DdUpBoxLabel"
          onClick={() => setIsOptionsVisible(!isOptionsVisible)}
        >
          <div className="DDbtnContainer">
            {isOptionsVisible ? (
              <span className="DDup-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon-tabler icon-tabler-chevron-up "
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 15 12 9 18 15"></polyline>
              </svg></span>
            ) : (
              <span className="DDdown-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon-tabler icon-tabler-chevron-down"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </span>
            )}
          </div>

          <hr />

          <div className="DDdisplayvalue">
            {inputBox ?
              <input
                type="number"
                className="dropdownInput"
                value={value}
                onChange={(evt) => {
                  if (onChange) {
                    onChange(evt.target.value);
                  }
                }}
              />
              : displayValue}
          </div>
        </div>



        {isOptionsVisible && (
          <div className="dropdown-options-aspect  ">
            {options?.map((option, ind) => (
              <div
                className="dropdown-option w-full"
                onClick={() => handleSelected(option.value)}
              >
                <div className={"dropdown-label-render" + (ind === selectedID ? " dropdown-label-render-selected" : '')}>{option.label}</div>
                <hr className="dropdown-hr" />
              </div>
            ))}

          </div>
        )}
      </div>
    </div>
  );
};
export default Dropdown_aspect;